<div class="row page-header">
    <div class="col-12">
        <h1>User Groups <small>Add users into various groups</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <div class="row" [hidden]="active !== 1">
        <div class="col-lg-3">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="groupsGrid"></action-toolbar-count>
                        <action-toolbar-buttons
                            [grid]="groupsGrid"
                            [canEdit]="canEdit"
                            [showAdd]="true"
                            [showEdit]="true"
                            [showDelete]="true"
                        ></action-toolbar-buttons>
                        <action-toolbar-search name="search" [(ngModel)]="groupsGrid.filter"></action-toolbar-search>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="gridGroups"
                        #gridGroups
                        appAutoSize
                        (initialized)="groupsGrid.initialize(gridGroups)"
                        (destroy)="groupsGrid.destroy()"
                        [itemsSource]="groupsGrid.view"
                        (selectionChanged)="getUsersforGroup()"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Group Name'" [binding]="'name'" [width]="'*'"></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>
        </div>
        <div class="col-lg-9" [hidden]="!groupsGrid.selectedItem">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="usersGrid"></action-toolbar-count>
                        <action-toolbar-search name="search" [(ngModel)]="usersGrid.filter"></action-toolbar-search>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="gridUsers"
                        #gridUsers
                        appAutoSize
                        (initialized)="usersGrid.initialize(gridUsers)"
                        (destroy)="usersGrid.destroy()"
                        [itemsSource]="usersGrid.view"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'User Name'" [binding]="'displayName'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Position Code'"
                            [binding]="'positionCode'"
                            [dataMap]="positionCodeMap"
                            [width]="'*'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'PR Group'"
                            [binding]="'prgroup'"
                            [dataMap]="prGroupMap"
                            [width]="120"
                            [align]="'left'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'PR Dept'"
                            [binding]="'prdept'"
                            [dataMap]="prDeptMap"
                            [width]="150"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Earn Code'"
                            [binding]="'earnCode'"
                            [dataMap]="earnCodeMap"
                            [width]="150"
                            [align]="'left'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Craft/Class'" [binding]="'stdClass'" [width]="125"></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>
        </div>
    </div>
</div>
